import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { linksUrl } from "../constants/enum";
import { setLogout } from "../state/authSlice.jsx"
import { resetCompCode } from "../state/companySlice.jsx"

function ErrorCard() {
  const { compCode } = useSelector((state) => state.company)
  const { isAuthenticated, user, tokenExpiry } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const navi = useNavigate()
  const handleClick = () => {
    if (tokenExpiry && tokenExpiry != "") {
      const currentTime = new Date().getTime() / 1000;
      if (currentTime > tokenExpiry || !isAuthenticated) {
        dispatch(setLogout())
        dispatch(resetCompCode())
        navi(linksUrl.login)
        //window.location.href = linksUrl.login;
      }
      else
        window.location.reload();
    }
    else {
      dispatch(setLogout())
      dispatch(resetCompCode())
      navi(linksUrl.login)
    }
  }
  return (
    <div className="bg-yellow-200 px-6 py-4 my-4 rounded-md text-lg flex gap-4  items-center mx-auto max-w-lg">
      <FontAwesomeIcon
        icon={faTriangleExclamation}
        className="text-yellow-600"
      />
      <span className="text-yellow-800">{isAuthenticated && user && compCode && compCode.length <= 0 ? (<div className="text-sm">Select Company  ! <Link to="/" style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700" >Click Here</Link> </div>) :
        (<div className="text-sm">Something went wrong ! click to <span on onClick={handleClick} style={{ color: "#eb8b0e" }} className="text-sm text-Rose-700  cursor-pointer underline" > Reconnect</span> </div>)} </span>
    </div>
  )
}
export default ErrorCard